import React from "react";
import AWS from "aws-sdk";
import PropTypes from "prop-types";
import { registerUser } from "react-cognito";
import ENVIRONMENT from "../../../../environments";
import { LoadingOutlined, LeftOutlined, ConsoleSqlOutlined } from "@ant-design/icons";
import { Input, Button, Row, Col, Select, Form, Checkbox, Upload, Progress, Radio } from "antd";
import { Link } from "react-router-dom";
import axios from "axios";
import { Country } from "country-state-city";
import Dashboard from "../../Dashboard";
import * as Constants from "../../CustomerComponents/Constants";
import * as Styles from "../../../../Styles";
import "./RegisterArtist.scss";
import { validateFileUploads } from "../../Utilities";
import LogInHeader from "../../../LogInHeader/LogInHeader";
import Footer from "../../../Footer/Footer";

const progress_bar = Styles.progress_bar;

const { Option } = Select;
const { Dragger } = Upload;

const skillsList = [
  "3DS Max",
  "Vray",
  "PBR",
  "USDZ",
  "GLTF",
  "Obj",
  "Z-Brush",
  "Photoshop",
  "Substance Painter",
  "Marvelous designer",
];

const formDiv = {
  display: "flex",
  "justify-content": "space-around",
  "margin-top": "10px",
};

const additionalFormDiv = {
  display: "flex",
  "justify-content": "space-around",
  "margin-top": "10px",
  marginBottom: "10px",
};

const formStyle = {
  "background-color": "white",
  "border-radius": "5px",
};

const options = ["No Proficiency", "Average Proficiency", "Good Proficiency"];

const map_prof_options = {
  "No Proficiency" : 0,
  "Average Proficiency" : 5,
  "Good Proficiency" : 10
}

class RegisterArtist extends React.Component {
  formRef = React.createRef();
  errorRef = React.createRef();

  constructor(props) {
    super(props);
    let email_regex = /email=([^&]+)/.exec(window.location.href); //extracted email
    let email = "";
    if (email_regex && email_regex[1]) {
      email = email_regex[1];
    }
    this.state = {
      error: null,
      username: null,
      profile_name: null,
      password: null,
      password_confirm: null,
      skype: '',
      email: email || null,
      isLoading: false,
      user_group: "test_artist",
      stage: 1,
      step: 1,
      user_type: "test_artist",
      years_of_experience: null,
      country: null,
      skills: null,
      proposed_hourly_rate: null,
      proposed_working_hours_per_week: null,
      writing_english_prof: null,
      reading_english_prof: null,
      listening_english_prof: null,
      portfolio_url: "",
      portfolio: [],
      uploading: false,
      errorFlag: false,
      children: [],
      portfolioFilesList: [],
      errorMessage: null,
      hasError: false,
      pricingMethod: 2,
      billing_type:null,
      artist_skills: {},
      artist_invite: null,
      agency_billing_rate: null,
      agency_billing_type: null,
      show_billing_fields: true,
      terms_agreed: false
    };
  }

  static propTypes = {
    history: PropTypes.object.isRequired,
  };

  componentDidMount() {
    let search_url = window.location.href;
    let email_regex = /email=([^&]+)/.exec(search_url); //extracted email
    let email = "";
    if (email_regex && email_regex[1]) {
      email = email_regex[1];
    }
    console.log("Email ", email);
    let email_to_lowercase = email.toLowerCase();
    this.setState({
      email: email_to_lowercase,
    });

    this.setState({
      user_type: "test_artist",
    });

    axios.post(ENVIRONMENT.SKILL_GET_BATCH, {})
    .then(res => {
      this.setState({skills: res['data']})
    })

    axios.post(ENVIRONMENT.ARTIST_INVITE_GET, {
      'email': email_to_lowercase
    }).then(res => {
      if(res['data']){
        let addition_details = res.data['additional_details']
        console.log('addition ', addition_details)
        if(addition_details && res.data['agency_name'] && !res.data['agency_admin']){
          if(addition_details['billing_type'] && addition_details['hourly_rate']){
            this.setState({agency_billing_type: addition_details['billing_type'],agency_billing_rate: addition_details['hourly_rate'], show_billing_fields: false})
          }
        }
      }
    })
  }


  componentDidUpdate() {
    if(this.state.error && this.errorRef.current)
      this.errorRef.current.scrollIntoView({ behavior: "smooth" });
  }

  loginUser = () => {
    this.setState({
      stage: 3,
    });
  };

  onChangeTermsAcceptance = (e) => {
    this.setState({terms_agreed: e.target.checked})
}

  onSelectSkill = (skill_name, skill_value) => {
    let skills = this.state.artist_skills;
    skills[skill_name] = skill_value
    this.setState({artist_skills: skills})
  }

  getSkillInitialValue = (skill_name) => {
    let skill_value = null
    for(let key in this.state.artist_skills){
      if(key == skill_name){
        skill_value = this.state.artist_skills[key]
      }
    }
    return skill_value
  }

  onSubmitContinue = (values) => {
    this.setState({ error: "" });
    if (this.state.username){
    this.setState({ isLoading: true });
    axios
      .post(ENVIRONMENT.GET_CUSTOMER_AND_COMPANY, { customer_username: this.state.username })
      .then((res) => {
        if(res.data.length > 0){
        if (res.data.customer_username == "") {
          // If no username is returned that means this username is unique
          this.setState({
            error: "",
          });
        } else {
          this.setState({ isLoading: false });
          this.setState({
            error: "A User with this username already exist",
          });
        }
        }
      });
    }
    if (
      this.state.email &&
      this.state.username &&
      this.state.password &&
      this.state.password_confirm
    ) {
      this.setState({ error: "" });
      let email_to_lowercase = this.state.email.toLowerCase();
      // if email is entered, validate if it is unique
      this.setState({ isLoading: true });
      axios
        .post(ENVIRONMENT.FETCH_USERNAME, { email: email_to_lowercase })
        .then((res) => {
          if (res.data.username == null) {
            // If no username is returned that means this email is unique
            if (
              this.state.password === this.state.password_confirm
            ) {
              if(this.state.error === ""){
              this.setState({ isLoading: false });
              this.setState({ step: 2 });
              }
            } else {
              this.setState({ isLoading: false });
              this.setState({
                error: "Passwords do not match",
              });
            }
          } else {
            this.setState({ isLoading: false });
            this.setState({
              error: "A User with this email address already exist",
            });
          }
        });
    }
  };

  onSubmit = (values) => {
    if(this.state.uploading){
      this.setState({error: "Uploads are in progress. Please wait for the uploads to complete."})
    }
    else {
      this.setState({ error: "" });
      this.setState({ isLoading: true });
      if (this.state.pricingMethod === 1) {
        this.setState({ billing_type: "hourly" });
      } else {
        this.setState({ billing_type: "per_model" });
      }

      let payload = {
        username: this.state.username,
        skype : this.state.skype,
        profile_name: this.state.profile_name,
        user_group: this.state.user_group,
        user_type: this.state.user_type,
        email: this.state.email.toLowerCase(),
        years_of_experience: this.state.years_of_experience,
        country: this.state.country,
        proposed_hourly_rate: this.state.proposed_hourly_rate,
        proposed_working_hours_per_week:
          this.state.proposed_working_hours_per_week,
        reading_english_proficiency:
          map_prof_options[this.state.reading_english_prof],
        writing_english_proficiency:
          map_prof_options[this.state.writing_english_prof],
        listening_english_proficiency:
          map_prof_options[this.state.listening_english_prof],
        portfolio_url: this.state.portfolio_url,
        portfolio_files: this.state.portfolioFilesList,
        action: "add_new_test_artist",
        billing_type: this.state.billing_type,
        skills: this.state.artist_skills
      };
      if(this.state.agency_billing_rate && this.state.agency_billing_type){
        payload.proposed_hourly_rate = this.state.agency_billing_rate;
        payload.billing_type = this.state.billing_type
      }

      if (this.state.password === this.state.password_confirm) {
        const { store } = this.context;
        const state = store.getState();
        const userPool = state.cognito.userPool;
        const config = state.cognito.config;
        this.setState({ isLoading: true });
        registerUser(userPool, config, this.state.username, this.state.password, {
          email: this.state.email.toLowerCase(),
        }).then(
          (action) => {
            store.dispatch(action);
            this.setState({ stage: 2 });
            this.setState({ isLoading: false });
            axios
              .post(ENVIRONMENT.TEST_ARTIST_CONTROLLER, payload)
              .then((res) => {
                console.log(res.data);
              });
          },
          (error) => {
            this.setState({ error, isLoading: false })
          }
        );
      } else {
        this.setState({ isLoading: false });
        this.setState({
          error: "Passwords do not match",
        });
      }
    }

  };

  changeUsername = (event) => {
    this.setState({ username: event.target.value });
  };

  changePassword = (event) => {
    this.setState({ password: event.target.value });
  };

  changePasswordConfirm = (event) => {
    this.setState({ password_confirm: event.target.value });
  };

  changeSkype = (event) => {
    this.setState({ skype: event.target.value });
  };

  changeYearsOfExperience = (event) => {
    this.setState({ years_of_experience: event.target.value });
  };
  changeHourlyRate = (event) => {
    this.setState({ proposed_hourly_rate: event.target.value });
  };

  changeWorkableHours = (event) => {
    this.setState({ proposed_working_hours_per_week: event.target.value });
  };

  handleSkillsChange = (value) => {
    if (value !== null || value !== "") {
      this.setState({ skills: value });
    }
  };

  changeURL = (event) => {
    this.setState({ portfolio_url: event.target.value });
  };
  changeEmail = (event) => {
    let email = event.target.value;
    this.setState({ email: email });
  };

  changeProfileName = (event) => {
    this.setState({profile_name: event.target.value})
  }

  onSelectCountry = (value) => {
    this.setState({
      country: value,
    });
  };

  onSelectListening = (value) => {
    this.setState({
      listening_english_prof: value,
    });
  };
  onSelectWritten = (value) => {
    this.setState({
      writing_english_prof: value,
    });
  };
  onSelectReading = (value) => {
    this.setState({
      reading_english_prof: value,
    });
  };

  handleChangePortfolioFiles = (info, check = null) => {
    let fileList = [...info.fileList];
    this.setState({ portfolioFilesList: fileList });
    console.log('File List = ', fileList)
    if(fileList.length > 0){
      this.setState({ uploading: true });
    }
    else{
      this.setState({uploading: false})
    }
    if (info.file.status === "done") {
      this.setState({ hasError: false });
      this.setState({ errorMessage: "" });
      this.setState({ uploading: false });
    } else if (info.file.status === "error") {
      this.setState({
        errorMessage: info.file.error.code.concat(
          "   " + info.file.error.message
        ),
      });
      if (info.file.error.code.includes("Credentials")) {
        this.setState({
          errorMessage: info.file.error.code.concat(
            ". Your session has expired. Please reload the page."
          ),
        });
      } else if (info.file.error.code.includes("Network")) {
        this.setState({
          errorMessage: info.file.error.code.concat(
            ". We are unable to upload due to an issue with your internet connection."
          ),
        });
      }
      this.setState({ hasError: true });
      this.setState({ uploading: false });
    }
  };

  setPhotoFileList = (fileList) => {
    this.setState({
      portfolioFilesList: fileList
    });
  }
  
  render = () => {
    return (
      <>

        {this.state.stage === 1 ? (
          <>
        <LogInHeader/>
          <Row className='justify-on-mobile'>
            <Col span={12} className='hide-on-mobile'>
              <img
                className="branding-image"
                // style={{ height: this.state.step === 1 ? "" : "100%" }}
                alt="Brand Image"
                src={'/img/introImage.png'}
              />
            </Col>
            {this.state.step === 1 ? (
              <Col xs={22} sm={22} md={24} lg={12} className='web-desktop-width mt-40'>
                <div
                   className="login-frm"
                  style={{ ...formDiv }}
                >
                  <div style={formStyle}>
                    <div style={formDiv}>
                      <div style={formStyle}>
                        
                        
                        <h3 className="manrope f-16 w-700 black-00">
                          Basic Information
                        </h3>
                        <Form
                          onFinishFailed={(e) => console.log(e)}
                          className="login-form"
                          layout="vertical"
                          ref={this.formRef}
                          initialValues={{
                            email: this.state.email || "",
                            profile_name: this.state.profile_name || "",
                            password: this.state.password || "",
                            password_confirm: this.state.password_confirm || "",
                            skype: this.state.skype || "",
                            username: this.state.username || "",
                          }}
                        >
                          <Form.Item
                            name="email"
                            rules={[
                              {
                                type: "email",
                                message: <span className='manrope f-14 red'>Please enter a valid email.</span>,
                              },
                              {
                                required: true,
                                message: <span className='manrope f-14 red'>Please enter your email!</span>,
                              },
                              {
                                pattern: "^[^\\s]+(\\s+[^\\s]+)*$",
                                message: <span className='manrope f-14 red'>Spaces are not allowed, whitespace found at the end.</span>,
                              },
                            ]}
                          >
                            <Input
                              disabled={
                                this.state.artist_invite &&
                                this.state.artist_invite.email
                                  ? true
                                  : false
                              }
                              onChange={this.changeEmail}
                              className='manrope f-14 w-400 placeholder black'
                              placeholder="Enter a valid email address"
                            />
                          </Form.Item>

                          <Form.Item
                            name="profile_name"
                            rules={[
                              {
                                required: true,
                                message: <span className='manrope f-14 red'>Please enter your name</span>,
                              },
                            ]}
                          >
                            <Input
                              onChange={this.changeProfileName}
                              className='manrope f-14 w-400 placeholder black'
                              placeholder="Enter your name"
                            />
                          </Form.Item>

                          <Form.Item
                            name="username"
                            rules={[
                              {
                                required: true,
                                message: <span className='manrope f-14 red'>Please enter your username </span>,
                              },
                              {
                                pattern: "^[^\\s]+(\\s+[^\\s]+)*$",
                                message:
                                <span className='manrope f-14 red'>Spaces are not allowed, whitespace found at the end.</span>,
                              },
                              {
                                pattern: "^[a-zA-Z0-9_]*$",
                                message:
                                <span className='manrope f-14 red'>Username can only contain alphanumeric or underscore</span>,
                              },
                            ]}
                          >
                            <Input
                              onChange={this.changeUsername}
                              className='manrope f-14 w-400 placeholder black'
                              placeholder="Enter a valid username"
                            />
                          </Form.Item>

                          <Form.Item
                            name="password"
                            rules={[
                              {
                                required: true,
                                message: <span className='manrope f-14 red'>Please enter your password </span>,
                              },
                              {
                                pattern:
                                  "^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$",
                                message:
                                <span className='manrope f-14 red'>Password should be at least 8 characters including at least one uppercase, one lower, one special character and a digit</span>,
                              },
                            ]}
                          >
                            <Input
                              onChange={this.changePassword}
                              type="password"
                              className='manrope f-14 w-400 placeholder black'
                              placeholder="Enter password"
                            />
                          </Form.Item>
                          <Form.Item
                            name="password_confirm"
                            rules={[
                              {
                                required: true,
                                message: <span className='manrope f-14 red'>Confirm password</span>,
                              },
                              {
                                pattern:
                                  "^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$",
                                message:
                                <span className='manrope f-14 red'>Password should be at least 8 characters including at least one uppercase, one lower, one special character and a digit</span>,
                              },
                            ]}
                          >
                            <Input
                              className='manrope f-14 w-400 placeholder black'
                              onChange={this.changePasswordConfirm}
                              type="password"
                              placeholder="Re-enter Password"
                            />
                          </Form.Item>

                          <Form.Item name="skype">
                            <Input
                              className='manrope f-14 w-400 placeholder black'
                              onChange={this.changeSkype}
                              placeholder="Enter your skype username"
                            />
                          </Form.Item>
                          
                          <Form.Item style={{display: 'flex'}}>
                          <Checkbox
                            style={{paddingTop: 10, display: 'flex'}}
                            // disabled={!scrolledToBottom} // Disable checkbox until scrolled to bottom
                            onChange={this.onChangeTermsAcceptance}
                          >
                           <span className="manrope f-14 black-33 sub-heading" style={{display: 'flex'}}>
                              I have read and agreed to&nbsp;
                              <br />
                              <a href="https://all3d.ai/three-d-terms" target="_blank">
                              3D Expert Service Agreement
                              </a>
                            </span>

                          </Checkbox>
                          </Form.Item>
                          <Form.Item>
                            <div className="flex-row">
                              <div className="w-80 manrope">Step 1/2</div>
                              <Progress
                                percent={50}
                                showInfo={false}
                                strokeColor="#276DD7"
                                trailColor="rgba(0, 0, 0, 0.12)"
                                style={{
                                  marginTop: 7,
                                }}
                              />
                              <div style={{ marginLeft: 244 }}>
                                {" "}
                                <Button
                                  type="primary"
                                  htmlType="submit"
                                  disabled={this.state.isLoading || !this.state.terms_agreed}
                                  className="login-button btn manrope f-14"
                                  style={{
                                    background: "#276DD7",
                                    color: 'white',
                                    borderRadius: 4,
                                  }}
                                  onClick={this.onSubmitContinue}
                                >
                                  Continue{" "}
                                  {this.state.isLoading ? (
                                    <LoadingOutlined spin />
                                  ) : (
                                    ""
                                  )}
                                </Button>
                              </div>
                            </div>
                          </Form.Item>

                          <Form.Item className="text-center">
                            <div className="text-center manrope f-14 w-500 black-00 mt-20">Already have an ALL3D account? <a href="/">Log in</a></div>

                          </Form.Item>
                        </Form>
                      </div>
                    </div>
                    {this.state.error ? (
                      <div
                        ref={this.errorRef}
                        className="manrope f-14 red text-center mt-10 mb-10"
                      >
                        {this.state.error}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </Col>
            ) : this.state.skills != {} ? (
              <Col xs={22} sm={22} md={24} lg={12} className='web-desktop-width mt-40'>
                <div
                 className="login-frm"
                 style={{ ...formDiv }}
                >
                  <div style={formStyle}>
                    <div style={additionalFormDiv}>
                      <div style={formStyle}>
                      <h3 className="manrope f-16 w-700 black-00">
                          Additional Information
                        </h3>
                        <Form
                          onFinish={this.onSubmit}
                          onFinishFailed={(e) => console.log(e)}
                          className="login-form"
                          ref={this.formRef}
                          initialValues={{
                            years_of_experience: this.state.years_of_experience,
                            ...Object.assign(
                              {},
                              ...this.state.skills.map((s) => {
                                let skill = {};
                                if(this.state.artist_skills[s["name"]] != undefined)
                                  skill[s.name] = this.state.artist_skills[s["name"]]
                                return skill;
                              })
                            ),
                            country: this.state.country,
                            proposed_hourly_rate:
                              this.state.proposed_hourly_rate,
                            proposed_working_hours_per_week:
                              this.state.proposed_working_hours_per_week,
                            writing_english_prof:
                              this.state.writing_english_prof,
                            listening_english_prof:
                              this.state.listening_english_prof,
                            reading_english_prof:
                              this.state.reading_english_prof,
                            portfolio_url: this.state.portfolio_url,
                          }}
                          layout="vertical"
                        >
                          <Form.Item
                            name="years_of_experience"
                            rules={[
                              {
                                required: true,
                                message:
                                <span className='manrope f-14 red'>Please enter your years of experience</span>,
                              },
                            ]}
                          >
                            <Input
                              type="number"
                              onChange={this.changeYearsOfExperience}
                              className='manrope f-14 w-400 placeholder black'
                              placeholder="Years you have worked in the field"
                            />
                          </Form.Item>

                          <div
                            style={{
                              color: "red",
                              display: "flex",
                              flexDirection: "row",
                              marginBottom: 0,
                            }}
                          >
                          </div>
                          <div
                            className="items-flex"
                            style={{
                              flexWrap: "wrap",
                              
                            }}
                          >
                            {this.state.skills.map((ele) => {
                              return (
                                <Form.Item
                                  style={{ minWidth: "49%" }}
                                  name={ele.name}
                                  rules={[
                                    {
                                      required: true,
                                      message: <span className='manrope f-14 red'>Select your proficiency</span>,
                                    },
                                  ]}
                                  className="w-32 sub-section"
                                >
                                  <Select
                                    className='manrope f-14 w-400 placeholder black'
                                    placeholder={ele.display_name}
                                    onSelect={(value) =>
                                      this.onSelectSkill(ele.name, value)
                                    }
                                  >
                                    <Option className='manrope f-14 w-400' value="Good" key="1">
                                      Good
                                    </Option>
                                    <Option className='manrope f-14 w-400' value="Average" key="2">
                                      Average
                                    </Option>
                                    <Option className='manrope f-14 w-400' value="Bad" key="3">
                                      Bad
                                    </Option>
                                  </Select>
                                </Form.Item>
                              );
                            })}
                          </div>
                          <Form.Item
                            name="country"
                            rules={[
                              {
                                required:
                                  this.state.country == null ? true : false,
                                message: "Please select your country",
                              },
                            ]}
                          >
                            <Select
                              allowClear
                              showSearch
                              className='manrope f-14 w-400 placeholder black'
                              placeholder="Select your country from the list"
                              value={this.state.country}
                              onSelect={this.onSelectCountry}
                            >
                              {Country.getAllCountries().map((ele, index) => {
                                return (
                                  <Option key={index + 1} value={ele.name}  className='manrope f-14 w-400'>
                                    {" "}
                                    {ele.name}{" "}
                                  </Option>
                                );
                              })}
                            </Select>
                          </Form.Item>
                          {this.state.show_billing_fields ? (
                            <React.Fragment>
                              <div className="items-flex">
                              <h3 className="manrope f-16 w-700 black-00">
                                Pricing Details (in USD)
                              </h3>
                                </div>
                                <div className="items-flex">
                                <Form.Item
                                      style={{ minWidth: "49%" }}
                                      name="proposed_hourly_rate"
                                      rules={[
                                        {
                                          required: true,
                                          message: <span className='manrope f-14 w-400'>Please provide your expected per model rate</span>,
                                        },
                                      ]}
                                >
                                  <Input
                                    type="number"
                                    className='manrope f-14 w-400 placeholder black'
                                    placeholder="Expected Per Model Rate"
                                    value={this.state.proposed_hourly_rate}
                                    onChange={this.changeHourlyRate}

                                  />
                                </Form.Item>
                                <Form.Item
                                  style={{ minWidth: "49%" }}
                                  name="proposed_working_hours_per_week"
                                  rules={[
                                    {
                                      required: true,
                                      message:
                                      <span className='manrope f-14 w-400'>Please provide your working hours</span>,
                                    },
                                  ]}
                                  className="w-32"
                                >
                                  <Input
                                    className='manrope f-14 w-400 placeholder black'
                                    onChange={this.changeWorkableHours}
                                    type="number"
                                    placeholder="Work hours per week"
                                  />
                                </Form.Item>
                              </div>
                            </React.Fragment>
                          ) : (
                            <Form.Item
                              name="proposed_working_hours_per_week"
                              rules={[
                                {
                                  required: true,
                                  message: <span className='manrope f-14 w-400'>Please provide your working hours</span>,
                                },
                              ]}
                              className="w-32"
                            >
                              <Input
                                className='manrope f-14 w-400 placeholder black'
                                onChange={this.changeWorkableHours}
                                type="number"
                                placeholder="Work hours per week"
                              />
                            </Form.Item>
                          )}
                          <div
                            style={{
                              color: "red",
                              display: "flex",
                              flexDirection: "row",
                              marginBottom: 0,
                            }}
                          >
                            * &nbsp;
                            <p
                              className="manrope f-14"
                              style={{ color: "#666666" }}
                            >
                              Proficiency in English
                            </p>
                          </div>
                          <div
                            className="items-flex"
                            
                          >
                            <Form.Item
                              name="writing_english_prof"
                              rules={[
                                {
                                  required: true,
                                  message: "",
                                },
                              ]}
                              className="w-32 sub-section"
                            >
                              <Select
                                className='manrope f-14 w-400 placeholder black'
                                placeholder={"Writing"}
                                onSelect={this.onSelectWritten}
                                value={this.state.writing_english_prof}
                              >
                                {options.map((x, index) => (
                                  <Option className='manrope f-14 w-400' value={x} key={index}>
                                    {x}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                            <Form.Item
                              name="reading_english_prof"
                              rules={[
                                {
                                  required: true,
                                  message: "",
                                },
                              ]}
                              
                              className="w-32 sub-section"
                            >
                              <Select
                                placeholder="Reading"
                                className='manrope f-14 w-400 placeholder black'
                                onSelect={this.onSelectReading}
                                value={this.state.reading_english_prof}
                              >
                                {options.map((x, index) => (
                                  <Option className='manrope f-14 w-400' value={x} key={index}>
                                    {x}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                            <Form.Item
                              name="listening_english_prof"
                              
                              rules={[
                                {
                                  required: true,
                                  message: "",
                                },
                              ]}
                              className="w-32 sub-section"
                            >
                              <Select
                                className='manrope f-14 w-400 placeholder black'
                                placeholder="Listening"
                                onSelect={this.onSelectListening}
                                value={this.state.listening_english_prof}
                              >
                                {options.map((x, index) => (
                                  <Option className='manrope f-14 w-400' value={x} key={index}>
                                    {x}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </div>

                          <Form.Item
                            name="portfolio"
                            label="Portfolio (file or url)"
                          >
                            <Dragger
                              {...Constants.upload_props}
                              multiple={true}
                              fileList={this.state.portfolioFilesList}
                              listType="text"
                              onDrop={(e) => {
                                console.log(e);
                                console.log("file dropped");
                              }}
                              onRemove={(file) => {
                                const index =
                                  this.state.portfolioFilesList.indexOf(file);
                                const newFileList =
                                  this.state.portfolioFilesList.slice();
                                newFileList.splice(index, 1);
                                this.setState({
                                  portfolioFilesList: newFileList,
                                });
                                newFileList.forEach((file) => {
                                  if (file.status !== "error") {
                                    this.setState({ hasError: false });
                                  } else {
                                    this.setState({ hasError: true });
                                  }
                                });
                                return true;
                              }}
                              onChange={this.handleChangePortfolioFiles}
                              accept=".jpg,.jpeg,.png,.zip,.pdf"
                              className="upload-box-hover-color"
                              progress={progress_bar}
                            >
                              <p className="">
                                <img
                                  className=""
                                  src={require("../../../../assets/images/ion_cloud-upload-outline.png")}
                                  alt=""
                                ></img>
                              </p>
                              <p className="ant-upload-text ">
                                Click or drag file to this area to upload
                              </p>
                              <p className="ant-upload-hint">
                                SUPPORTED FORMATS: PDF, JPG, ZIP
                              </p>

                              {validateFileUploads(
                                this.state.portfolioFilesList
                              ) == "error" && (
                                <Button
                                  onClick={() =>
                                    Constants.triggerFailedFilesUpload('portfolio', this.state.portfolioFilesList, this.setPhotoFileList)
                                  }
                                  disabled={
                                    this.state.portfolioFilesList.length === 0
                                  }
                                  loading={this.state.uploading}
                                  className="retry-btn multiple manrope f-12"
                                  ghost
                                >
                                  {this.state.uploading ? (
                                    <span>Retrying...</span>
                                  ) : (
                                    "Upload Failed. Click to Retry."
                                  )}
                                </Button>
                              )}
                            </Dragger>
                          </Form.Item>

                          <Form.Item name="portfolio_url">
                            <Input
                              className='manrope f-14 w-400 placeholder black'
                              value={this.state.portfolio_url}
                              onChange={this.changeURL}
                              placeholder="Portfolio URL (ArtStation, Behance, etc.)"
                            />
                          </Form.Item>

                          <Form.Item>
                            <div className="flex-row">
                              <div className="w-80 manrope">Step 2/2</div>
                              <Progress
                                percent={100}
                                showInfo={false}
                                strokeColor="#276DD7"
                                style={{
                                  marginTop: 7,
                                }}
                              />
                              <div
                                className="flex-row"
                                style={{ marginLeft: 130, float: "right" }}
                              >
                                <Button
                                  className="back-button manrope f-14"
                                  onClick={() => {
                                    this.setState({
                                      step: 1,
                                    });
                                  }}
                                >
                                  <LeftOutlined />
                                  Back{" "}
                                </Button>
                                <Button
                                  type="primary"
                                  htmlType="submit"
                                  className="login-button btn manrope f-14"
                                  style={{
                                    background: "#276DD7",
                                    color: 'white',
                                    borderRadius: 4,
                                  }}
                                >
                                  Create Account{" "}
                                  {this.state.isLoading ? (
                                    <LoadingOutlined spin />
                                  ) : (
                                    ""
                                  )}
                                </Button>
                              </div>
                            </div>
                          </Form.Item>
                        </Form>
                      </div>
                    </div>
                    {this.state.error ? (
                      <div
                        ref={this.errorRef}
                        className="text-danger text-center mb-10"
                        style={{ paddingBottom: 20 }}
                      >
                        {this.state.error}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </Col>
            ) : (
              ""
            )}
          </Row>
          <Footer/>
          </>
          
        ) : (
          <span>
            {this.state.stage === 2 ? (
              <Dashboard loginUser={this.loginUser} />
            ) : (
              <Dashboard
                registerUsername={this.state.username}
                registerPassword={this.state.password}
              />
            )}
          </span>
        )}
        
      </>
    );
  };
}

RegisterArtist.contextTypes = {
  store: PropTypes.object,
};

export default RegisterArtist;
